<h1 class="content-heading">{{ title }}</h1>
<div [ngStyle]="styles">
	<ng-content></ng-content>
</div>
